<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="area-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-area"></div>
                    <div class="area-view">
                        <div class="area-box">
                        <p class="now" @click="listShow = true"><span>绑定大区：</span>{{ now.name }}<em class="select"></em></p>
                        <ul class="area-list" v-if="listShow">
                            <li v-for="area in areas[account_type]"
                            :key = "area.id"
                            v-bind:data-aid="area.id"
                            v-bind:data-name="area.name"
                            @click="queryPlayer" v-html="area.name">{{ area.name }}</li>
                        </ul>
                        </div>
                        <div class="player-name"><p><span>角色昵称：</span>{{ now.playerName }}</p></div>
                    </div>
                    <p class="warn"><em class="icon i-warn"></em>绑定大区后不可修改！请仔细核对参与角色。</p>
                    <div class="u-btn submit" @click="bindArea"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
            },
            areas: {
                pc: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }],
                wg: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                }]
            },
            visible : false,
            account_type : 'pc',
            code : '',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },       
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
            localStorage.setItem("code", "");
        },
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');
             
            this.$axios.get(this.$global.ajax_url_map.queryplayer, {
                params: {
                    areaId : vue.now.id,
                }
            })
            .then(function (response) {
                if(response.data.code === 0){
                    vue.$toast('查询成功');
                    vue.now.playerName = response.data.data.petName;
                }
                else{
                    vue.$toast(response.data.message);
                    vue.now.playerName = '';
                }             
            })
            .catch(function (error) {
                console.log(error);
            });             

        },
        bindArea(e){
            var _s = e.target;
            var vue = this;

            //todo inviteCode
            if(!vue.now.playerName)return vue.$toast('端游未创角');
            this.$axios.post(this.$global.ajax_url_map.bind, {
                areaId : vue.now.id,
            })
            .then(function (response) {
                if(response.data.code === 0){
                    vue.$update();
                    vue.$toast('大区绑定成功');
                    vue.destroyElement();

                    if(vue.code)vue.$get_help_info();
                }
                else{
                    vue.$toast(response.data.message);
                }             
            })
            .catch(function (error) {
                console.log(error);
            });   
        },
    },    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .area-modal{
        width: 469px;
        height: 381px;
        background-image: url(../../images/bg-modal-bind.png);
    }

    .dialog-wrapper{
        padding-top: 40px;
    }

    .t-area{
        width: 173px;
        height: 40px;
        margin: 0 auto 20px;
        background-image: url(../../images/title-bind.png);
    }

    .area-view{
        margin-top: 40px;
    }

    .area-view .area-box {
        position: relative;
        width: 275px;
        height: 45px;
        line-height: 45px;
        margin: 0 auto 10px;
        box-sizing: border-box;
        color: #927e6a;
        vertical-align: middle;
        border: 1px solid #ab957e;
        z-index: 10;
    }

    .area-box p {
        position: relative;
        padding-left: 30px;
        line-height: 45px;
        color: #44342a;
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 20px;
        width: 19px;
        height: 13px;
        transform: translateY(-50%);
    }

    .area-box .now .select::after{
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(../../images/icon-select.png);
        background-position: center;
        background-repeat: no-repeat;
    }  

    .area-box .now span {
        padding-right: 12px;
        color: #927e6a;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 46px;
        left: 50%;
        width: 100%;
        padding: 0 7px;
        color: #927e6a;
        z-index: 30;
        background-color: #eee0c2;
        box-sizing: border-box;
        transform: translateX(-50%);
        border: 1px solid #ab957e;
    }

    .area-view .area-list li {
        display: inline-block;
        min-width: 50%;
        line-height: 36px;
        text-align: center;
        box-sizing: content-box;
        border-bottom: 1px dashed #dfc5aa;
        cursor: pointer;
        transition: all .3 ease-in;
    }

    .area-view .area-list li:hover{
        color: #44342a;
    }

    .area-view .area-list li:nth-last-child(1),
    .area-view .area-list li:nth-last-child(2){
        border-bottom: none;
    }

    .area-view .player-name {
        position: relative;
        width: 275px;
        height: 45px;
        line-height: 45px;
        margin: 0 auto 10px;
        box-sizing: border-box;
        color: #44342a;
        vertical-align: middle;
        border: 1px solid #ab957e;
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 30px;
        padding-right: 12px;
        color: #927e6a;        
    }


    .area-modal .u-btn.submit{
        width: 166px;
        height: 49px;
        margin: 25px auto 0;
        background-image: url(../../images/btn-ok.png);    
    }
    
    .area-modal .u-btn.submit:hover{
        background-image: url(../../images/btn-ok_hover.png);   
    }

    .area-modal .warn{
        margin-bottom: 15px;
        line-height: 1.6;
        color: #9f392f;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        vertical-align: text-bottom;
        width: 17px;
        height: 17px;
        margin-right: 15px;
        background-image: url(../../images/icon-warn.png);
    }
}

@media screen and (max-device-width: 1024px){
    .area-modal{
        width: 609px;
        height: 411px;
        background-image: url(../../images/m/bg-modal-bind.png);
    }

    .dialog-wrapper{
        padding-top: 40px;
    }

    .t-area{
        width: 208px;
        height: 48px;
        margin: 0 auto 10px;
        background-image: url(../../images/m/title-bind.png);
    }

    .area-view{
        margin-top: 20px;
    }

    .area-view .area-box {
        position: relative;
        width: 480px;
        height: 55px;
        line-height: 55px;
        margin: 0 auto 10px;
        box-sizing: border-box;
        color: #927e6a;
        vertical-align: middle;
        border: 1px solid #ab957e;
        z-index: 10;
    }

    .area-box p {
        position: relative;
        padding-left: 30px;
        line-height: 55px;
        color: #44342a;
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 20px;
        width: 19px;
        height: 13px;
        transform: translateY(-50%);
    }

    .area-box .now .select::after{
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(../../images/icon-select.png);
        background-position: center;
        background-repeat: no-repeat;
    }  

    .area-box .now span {
        padding-right: 12px;
        color: #927e6a;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 56px;
        left: 50%;
        width: 100%;
        padding: 0 7px;
        color: #927e6a;
        z-index: 30;
        background-color: #eee0c2;
        box-sizing: border-box;
        transform: translateX(-50%);
        border: 1px solid #ab957e;
    }

    .area-view .area-list li {
        display: inline-block;
        min-width: 50%;
        line-height: 36px;
        text-align: center;
        box-sizing: content-box;
        border-bottom: 1px dashed #dfc5aa;
        cursor: pointer;
        transition: all .3 ease-in;
    }

    .area-view .area-list li:hover{
        color: #44342a;
    }

    .area-view .area-list li:nth-last-child(1),
    .area-view .area-list li:nth-last-child(2){
        border-bottom: none;
    }

    .area-view .player-name {
        position: relative;
        width: 480px;
        height: 55px;
        line-height: 55px;
        margin: 0 auto 10px;
        box-sizing: border-box;
        color: #44342a;
        vertical-align: middle;
        border: 1px solid #ab957e;
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 30px;
        padding-right: 12px;
        color: #927e6a;        
    }


    .area-modal .u-btn.submit{
        width: 218px;
        height: 65px;
        margin: 25px auto 0;
        background-image: url(../../images/m/btn-ok.png);    
    }
    

    .area-modal .warn{
        margin-bottom: 15px;
        line-height: 1.6;
        color: #9f392f;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        vertical-align: text-bottom;
        width: 23px;
        height: 23px;
        margin-right: 15px;
        background-image: url(../../images/m/icon-warn.png);
    }    
}
</style>


// WEBPACK FOOTER //
// src/components/AreaBind/areaModal.vue